import React from "react";

export const StatusBadge = ({ code, className = "" }) => {

  const map = {
    O: {
      text: "Open",
      bg: "bg-orange-50",
      border: "border-orange-200",
      textColor: "text-orange-700",
    },
    P: {
      text: "In Progress",
      bg: "bg-blue-50",
      border: "border-blue-200",
      textColor: "text-blue-700",
    },
    C: {
      text: "Closed",
      bg: "bg-green-50",
      border: "border-green-200",
      textColor: "text-green-700",
    },
  };

  const s = map[code] || map.O;

  return (
    <span
      className={`inline-flex items-center px-3 py-1 text-xs font-medium border montserrat-font-1 rounded-full ${s.bg} ${s.border} ${s.textColor} ${className}`}
    >
      {s.text}
    </span>
  );
};


export const PriorityBadge = ({ value }) => {

  const v = String(value || "").toLowerCase();

  const map = {
    low: {
      text: "Low",
      bg: "bg-blue-50",
      border: "border-blue-200",
      textColor: "text-blue-700",
    },
    medium: {
      text: "Medium",
      bg: "bg-yellow-50",
      border: "border-yellow-200",
      textColor: "text-yellow-700",
    },
    high: {
      text: "High",
      bg: "bg-red-50",
      border: "border-red-200",
      textColor: "text-red-700",
    },
    urgent: {
      text: "Urgent",
      bg: "bg-orange-50",
      border: "border-orange-200",
      textColor: "text-orange-700",
    },
  };

  const s = map[v] || map.medium;

  return (
    <span
      className={`inline-flex items-center px-3 py-1 text-xs font-medium border montserrat-font-1 rounded-full ${s.bg} ${s.border} ${s.textColor}`}
    >
      {s.text}
    </span>
  );
};